import { createSlice } from "@reduxjs/toolkit";

const trainStationSlice = createSlice({
  name: "trainStation",
  initialState: {
    selectedStation: null,
    selectedStationCity: "Mumbai",
    isStationSelected: false,
  },
  reducers: {
    selectTrainStation: (state, action) => {
      state.selectedStation = action.payload;
      state.isStationSelected = !!action.payload;
    },
    selectStationCity: (state, action) => {
      state.selectedStationCity = action.payload;
    },
    clearTrainStation: (state) => {
      state.selectedStation = null;
      state.isStationSelected = false;
    },
  },
});

export const { selectTrainStation, selectStationCity, clearTrainStation } =
  trainStationSlice.actions;
export default trainStationSlice.reducer;
